import React from "react";

const CartProgressSkeleton: React.FC = () => {
  return (
    <>
      <div className="flex items-start justify-around mb-12">
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full items-center after:absolute after:top-5 max-sm:after:top-[14px] after:left-1/2 after:z-[-1] after:content-[''] after:w-full after:border-b after:border-[#9CA3AF70] after:border-4 after:inline-block">
          <div className="flex items-center flex-col gap-1">
            <div className="h-11 w-11 max-sm:w-8 max-sm:h-8 skeleton !rounded-full"></div>
            <span className="text-primary text-xl max-sm:text-sm">
              <div className="h-4 w-40 max-sm:w-20 max-sm:h-3 skeleton !rounded-md"></div>
            </span>
          </div>
        </div>
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full items-center after:absolute after:top-5 max-sm:after:top-[14px] after:left-1/2 after:z-[-1] after:content-[''] after:w-full after:border-b after:border-[#9CA3AF70] after:border-4 after:inline-block">
          <div className="flex flex-col items-center gap-1">
            <div className="h-11 w-11  max-sm:w-8 max-sm:h-8 skeleton !rounded-full"></div>
            <span className="text-[#B1B5C3] text-xl max-sm:text-sm">
              <div className="h-4 w-40 max-sm:w-20 max-sm:h-3 skeleton !rounded-md"></div>
            </span>
          </div>
        </div>
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full">
          <div className="flex flex-col items-center gap-1">
            {/* <div className="w-11 h-11 max-sm:w-8 max-sm:h-8 text-[#3E474A] grid place-items-center text-2xl rounded-full bg-blue border-2 border-primary"></div> */}
            <div className="h-11 w-11 max-sm:w-8 max-sm:h-8 skeleton !rounded-full"></div>
            <span className="text-[#B1B5C3] text-xl max-sm:text-sm">
              <div className="h-4 w-40 max-sm:w-20 max-sm:h-3 skeleton !rounded-md"></div>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartProgressSkeleton;
